export default __webpack_public_path__ + "static/media/CNo.45-5.55ef755e.jpg";